import {FC, MouseEvent, useState} from 'react'
import {storeBooking} from "../../lib/booking";
import {formatSlug} from "../../lib/helpers";
import CheckBox from "../common/Checkbox/Checkbox";

interface Props {
    option:any,
    booking:Booking,
    setBooking:Function
}

const ServiceAgreement: FC<Props> = ({option, booking, setBooking}) => {

    const [acceptContact, setAcceptContact] = useState(booking.options_extra.service_agreement);

    if(!option.car_brands.includes(formatSlug(booking.car.brand)) || !option.active || booking.booking_flow === 'hjulskifte') {
        return
    }

    if(booking.options_extra.service_agreement === 'disabled') {
        booking.options_extra.service_agreement = 'required'
        storeBooking(booking, setBooking)
    }

    const handleCheckBox = (box:string, value:any) => {
        booking.options_extra.service_agreement = box
        setAcceptContact(box)
        storeBooking(booking, setBooking)
    }

    const openInfo =  (event: MouseEvent) => {
        booking.modal = 13;
        booking.modal_message = option.info
        storeBooking(booking, setBooking)
    }

    return (
        <>
            <ul className="wco-order-options_list brand-extra-option">
                <li className="volvo-mechanic input-outer chk-box">
                    <div className="li-text">
                        <div className="description">
                            <h3 className={"required"}>{option.header}</h3>
                            <div>{option.description}</div>
                        </div>
                        <div className="input-outer">
                            <div className={"product-hotel-container_choice"}>
                                <CheckBox radio={true} title={option.yes} active={acceptContact === 'yes'} type={'yes'}
                                          handle={handleCheckBox}/>
                                <CheckBox radio={true} title={option.no} active={acceptContact === 'no'} type={'no'}
                                          handle={handleCheckBox}/>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </>
    )
};

export default ServiceAgreement
